// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4e7b61d1","455":"afdc24f2","488":"b9ac3c96","977":"2a3dda65"}[chunkId] + ".chunk.js";
};